import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    gap: theme.spacing(3),

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },

  card: {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    flex: 1,
    gap: theme.spacing(3),
    padding: theme.spacing(4),
    borderRadius: 12,
    border: `2px solid ${theme.palette.mode === 'dark' ? theme.palette.background.paper : alpha(theme.palette.divider, 0.1)}`,
  },

  type: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },

  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    color: theme.palette.text.secondary,
  },

  divider: {
    height: 12,
    borderColor: theme.palette.text.secondary,
  },
}));
